import React from 'react';

// PDF-only compact legend shown in place of the click-to-open "Understanding our colour
// scales" popup, since the PDF export has no click interactions. See downloadPersonalisedPlanPdf.ts.
const painColorScale = [
  { level: 'Very Tight', color: '#FF0004' },
  { level: 'Tight', color: '#FF8184' },
  { level: 'Moderate', color: '#F3A742' },
  { level: 'Flexible', color: '#2AD76F' },
  { level: 'Very Flexible', color: '#2AD76F' }
];

const ColourScaleLegend: React.FC = () => (
  <div className="flex flex-col gap-[10px]">
    <p className="text-[13px] font-medium leading-[16px] font-Inter text-[#8d8d8d] m-0">
      Understanding our flexibility colour scales
    </p>
    <div className="flex flex-wrap items-center gap-[20px]">
      {painColorScale.map((item, index) => (
        <div key={index} className="flex items-center gap-[8px]">
          <span
            className="shrink-0 w-[16px] h-[16px] rounded-full relative top-[7px]"
            style={{ backgroundColor: item.color }}
          />
          <span className="text-[13px] font-medium leading-[16px] font-Inter text-[#333]">
            {item.level}
          </span>
        </div>
      ))}
    </div>
  </div>
);

export default ColourScaleLegend;
